import { getFilterOrder } from './computeFilters';
import React, { Fragment } from 'react';


const componentFilters = {
  0:{type:'discrete',tableValues:"0 0 0 0 0 0 0 0"},
  1:{type:'identity'}
}

const colorMap = {
  none:[1,1,1],
  red:[1,0,0],
  green:[0,1,0],
  blue:[0,0,1],
  magenta:[1,0,1],
  yellow:[1,1,0],
  cyan:[0,1,1],
  grey:[0.2989,0.5870,0.114],
  grey:[1,1,1],


}

export function computeFilterArgs(adjustments){

  let filterOrder = getFilterOrder(adjustments);
  let filterArgs = [];
  
  filterOrder.forEach(filterKey => {
    let filterValue = adjustments[filterKey]
    if( filterValue ){
      let thisFilterArgs = getFilterArgs({filterKey,filterValue})
      filterArgs.push(thisFilterArgs);
    }
  })

  filterArgs.forEach((args,ii) => {
    args.inKey = ii === 0 ? "SourceGraphic" : `${ii-1}-out`;
    args.result = ii === filterArgs.length - 1 ? 'source' : `${ii}-out`;
  })

  return filterArgs;

}


function getFilterArgs({filterKey,filterValue}){

  if( filterKey === "contrast" ){
    let intercept = -0.5 * filterValue + 0.5;
    return { type:"linear", slope:filterValue, intercept, filterKey };
  }else if( filterKey === "brightness" ){
    return { type:"linear", slope:filterValue, intercept:0, filterKey }
  }else if( filterKey === "inverted" ){
    return { type:"linear", slope:-1, intercept:1, filterKey }
  }else if( filterKey === "colorProjection" ){
    //debugger;
    return { type:"colorProjection", filterKey, filterValue }
  }else if( filterKey === "gamma" ){
    return { type:"gamma", filterKey, filterValue, amplitude:1, exponent:filterValue, offset:0 }
  }

}

function colorComponentTransfer({inKey,result,filterValue}){

  let colorProjection = filterValue;
  let [color] = colorProjection;
  let elements = colorMap[color];

  if( !color || !filterValue || filterValue === "none" ){

    elements = [1,1,1]

   return (
    <feComponentTransfer {...{in:inKey,result}}>
      <feFuncR {...componentFilters[ elements[0] ] }/>
      <feFuncG {...componentFilters[ elements[1] ] }/>
      <feFuncB {...componentFilters[ elements[2] ] }/>
    </feComponentTransfer>
  )
  }


  return (
    <feComponentTransfer {...{in:inKey,result}}>
      <feFuncR {...componentFilters[ elements[0] ] }/>
      <feFuncG {...componentFilters[ elements[1] ] }/>
      <feFuncB {...componentFilters[ elements[2] ] }/>
    </feComponentTransfer>
  )
}

function gamma({inKey,result,filterValue}){

  let gamma = filterValue;
  let elements;// = colorMap[color];

  if( !filterValue || filterValue === "none" ){

    //debugger;
    return null;
  }


  return (
    <feComponentTransfer {...{in:inKey,result}}>
      <feFuncR {...componentFilters[ elements[0] ] }/>
      <feFuncG {...componentFilters[ elements[1] ] }/>
      <feFuncB {...componentFilters[ elements[2] ] }/>
    </feComponentTransfer>
  )
}


function FeComponentTransfer({ inKey, result, slope, intercept, ...args }){


  let innerFunctions = ["R","G","B"].map( letter => {
    let comp = "feFunc"+letter;
    return React.createElement(comp,{
      type:"linear",
      slope,
      intercept,
      ...args,
    })
  })

  return (
    <feComponentTransfer {...{in:inKey, result} }>
      {innerFunctions}
    </feComponentTransfer>
  )


}

export default function SvgImageFilter({filterArgs}){
  if( filterArgs.length === 0 ){
    return null;
  }

  return (

    <filter colorInterpolationFilters="sRGB" id={filterArgs.filterId} x="0%" y="0%" width="100%" height="100%">
      {filterArgs.map((args,i) => {

        if( args.filterKey === "colorProjection" ){
          return <Fragment key={i}>{colorComponentTransfer(args)}</Fragment>;
        }else{
          return <FeComponentTransfer key={i} {...{...args}}/>
        }
      })}
      
    </filter>
  )
}
